export default __webpack_public_path__ + "static/media/desktop.7ed35408.svg";